module.exports = __webpack_public_path__ + "static/media/logo_light.e0610d84.svg";


//////////////////
// WEBPACK FOOTER
// ./public/image/logo_light.svg
// module id = 22
// module chunks = 0